import React from 'react'
import { Link, Typography } from '@material-ui/core'

export default function Copyright(): React.ReactElement {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {'Copyright © '}
      <Link color="inherit" href="https://www.mitsufuji.co.jp">
        Mitsufuji Corporation.
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  )
}
